import { stipReportAxios } from '../axios';

const reportEndpoints = {
    generateReportFile: (reportId, filters) =>
        stipReportAxios.post(`/gerar/${reportId}`, filters, { responseType: 'arraybuffer' }),
};

export default reportEndpoints;
